import {
  BellIcon, CubeIcon, DevicePhoneMobileIcon, MegaphoneIcon, RectangleStackIcon, SparklesIcon, TagIcon, UserGroupIcon,
} from '@heroicons/react/24/outline'

/**
 * Co daje darmowe konto: lista na rejestracji (`/rejestracja`) i przy logowaniu (`/logowanie`, dla osób bez konta).
 *
 * Trzy pozycje wyprzedzają funkcje (indywidualne oferty, powiadomienia o promocjach, przydzielanie zestawów do
 * klientów): decyzja właściciela z 2026-08-11, opis ryzyka w `KafelekRejestracji.jsx`.
 */
export const KORZYSCI_KONTA = [
  { Icon: SparklesIcon, tytul: 'Asystent doboru dopasowany do Ciebie', opis: 'Marki, sklepy i sprzęt, na którym pracujesz.' },
  { Icon: TagIcon, tytul: 'Indywidualne oferty', opis: 'Przygotowane pod Twoją sytuację.' },
  { Icon: BellIcon, tytul: 'Powiadomienia o promocjach', opis: 'Dowiesz się, kiedy pojawi się okazja.' },
  { Icon: DevicePhoneMobileIcon, tytul: 'Obserwowane produkty zostają na koncie', opis: 'Znajdziesz je też na telefonie.' },
  { Icon: RectangleStackIcon, tytul: 'Zapisane zestawy', opis: 'Wracaj do nich i przydzielaj je do klientów.' },
]

/** Konto firmowe (rejestracja z wybraną firmą, np. `/rejestracja?konto=firma` z „Dla firm PV”, 2026-10-24). */
export const KORZYSCI_FIRMY = [
  { Icon: MegaphoneIcon, tytul: 'Zlecenia klientów z okolicy', opis: 'Po krótkiej ankiecie zapraszamy Was do zleceń z Rynku.' },
  { Icon: SparklesIcon, tytul: 'Dobór sprzętu z aktualnych ofert', opis: 'Zgodność falownika i magazynu sprawdzona automatycznie.' },
  { Icon: CubeIcon, tytul: 'Projekt 3D i oferta PDF', opis: 'Z logo firmy, prognozą produkcji i zwrotem z inwestycji.' },
  { Icon: UserGroupIcon, tytul: 'Klienci i zespół w jednym miejscu', opis: 'Etapy, terminy montaży i konta dla handlowców i ekip.' },
]
